import { createContext } from "react";

import type { KillswitchContext } from "./types";

export const Context = createContext<KillswitchContext>({
  addKillswitch: () => {},
  getKillswitch: () => undefined,
  removeKillswitch: () => {},
});
